/** A never-completed upload leaves a placeholder-titled `draft` orphan — hide it from listings. */
export function isOrphanDraft(status: string, title: string): boolean {
  return status === "draft" && (title === "（撮影中のマニュアル）" || title === "（無題のマニュアル）");
}
